<p-dialog [(visible)]="showSessionTimeoutWarning" [style]="{ width: '50vw' }" [closable]="false" [closeOnEscape]="false" [header]="title" [modal]="true" [draggable]="false" [resizable]="false" [appendTo]="'body'" [autoZIndex]="true" [baseZIndex]="4000" [focusTrap]="true" [blockScroll]="true" styleClass="session-timeout-dialog" maskStyleClass="session-timeout-mask">
  
  <p class="m-0">
    {{message}}
  </p>

  <div class="d-flex justify-content-center" *ngIf="hideFooter == false">
      <button type="button" pButton icon="pi pi-check" (click)="onKeepIn()" class="mr-1 p-button-text" [disabled]="keepAlivePending">{{keepAliveButton}}</button>
      <button type="button" pButton icon="pi pi-sign-out" (click)="onLogout()" class="ml-1 p-button-text" [disabled]="keepAlivePending">{{logoutButton}}</button>
  </div>
</p-dialog>
